import { REFIT_PADDING } from '@/constants/map';
const KM_MILES = 0.62137;

/**
 * Takes an array of geopoints and calculates a bounding box that will display them all.
 */
export const generateBoundingBox = (
  locations: { lon: number; lat: number }[] = [],
): [[number, number], [number, number]] => {
  // Valid ranges for lat and lon
  let latMin = 90;
  let latMax = -90;
  let lngMin = 180;
  let lngMax = -180;

  locations.forEach(location => {
    lngMin = Math.min(lngMin, location.lon);
    lngMax = Math.max(lngMax, location.lon);
    latMin = Math.min(latMin, location.lat);
    latMax = Math.max(latMax, location.lat);
  });

  return [
    [lngMin - REFIT_PADDING, latMin - REFIT_PADDING],
    [lngMax + REFIT_PADDING, latMax + REFIT_PADDING],
  ];
};

export function getDistanceFromLatLonInMiles(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number {
  return getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) * KM_MILES;
}

function getDistanceFromLatLonInKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

function deg2rad(deg: number) {
  return deg * (Math.PI / 180);
}
